import React, { useMemo, useState, useEffect } from "react";
import { ButtonDelete, ButtonSmall } from "../common/Buttons";
import { DebounceSelect } from "../common";
import ModalSpecial from "../Layout/Modals/ModalSpecial";
import { IconEdit, IconSadFace, IconExclamation } from "../Layout/Icons";
import TableUi from "../Layout/TableUI";
import TextInputModal from "../common/TextInputModal";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../common/Spinner";
import SwitchComp from "../common/SwitchComp";
import { postSupplyingIncome } from "../../redux/Actions/also_incomes_action";
import useFetch from "../../hooks/useFetch";
import ButtonSecondary from "../common/ButtonSecondary";
import DataPickerInputModal from "../common/DataPickerInputModal";
import { errorHandler, getDateFormat } from "../../helpers/Utils";
import useDebounce from "../../hooks/useDebounce";
import Axios from "axios";
import moment from "moment";
import { Radio, Select, Modal, Button, message, Input } from "antd";
import { removeOverFlow } from "../../helpers/modalFunc";
import { Label } from "../globals";
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import AntdConfirm from "../../helpers/AntdConfirm";

const { confirm } = Modal;

const initialStateItem = {
  id: null,
  sku: "",
  vv_sku: "",
  barcode: "",
  product_title: "",
  qty: 1,
  used_qty: 0,
  product_id: null,
  min_quantity: 0
};

const RESTRICTED_STATUSES = ["in_progress", "income_started", "income_ended", "completed", "canceled"];

const ModalAlsoIncomeModule = ({ modalFunc, id, history }) => {
  const user = useSelector((state) => state.auth.user);
  const { value, setValue, loading: fetchLoading, error } = useFetch(
    `/api/v1/also_incomes/${id == 0 ? "new" : id}`,
    {},
    [id]
  );

  const [itAlreadyExist, setAlreadyExist] = useState(true);
  const [invoiceItem, setInvoiceItem] = useState(initialStateItem);
  const [selectedValue, setSelectedValue] = useState("ALSO");
  const [reviewDate, setReviewDate] = useState(moment());
  const [supplyDate, setSupplyDate] = useState(moment());
  const [isLoading, setIsLoading] = useState(false);
  const [disabledDates, setDisabledDates] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [vvSkuStatus, setVvSkuStatus] = useState({ valid: true, message: "" });
  const [vvSkuText, setVvSkuText] = useState("");
  const [loading, setLoading] = useState(false);
  const [userTypedVvSku, setUserTypedVvSku] = useState(false);
  const [quantityWarning, setQuantityWarning] = useState({ show: false, message: "" });
  const dispatch = useDispatch();
  const validate = ["product_title", "sku", "qty"];
  const validateForm = ["supplier_id", "arrival_date"];
  const [barcodeEditMode, setBarcodeEditMode] = useState(false);
  const [vvSkuEditMode, setVvSkuEditMode] = useState(false);
  const [editingVvSkuIdx, setEditingVvSkuIdx] = useState(null);
  const [editingVvSkuValue, setEditingVvSkuValue] = useState("");

  const isRestrictedStatus = RESTRICTED_STATUSES.includes(value?.status);

  useEffect(() => {
    if (value?.add_to) setSelectedValue(value?.add_to.toUpperCase() || "ALSO");
  }, [value?.add_to]);

  useDebounce(
    () => {
      if (value?.id) return;
      if (!value?.order_date || !value?.supplier_id || !value?.arrival_date || !value?.add_to)
        return;
      Axios.get(
        `/api/v1/also_incomes/it_already_exist?order_date=${value.order_date}&supplier_id=${value.supplier_id}&arrival_date=${value.arrival_date}&add_to=${value.add_to}`
      ).then((response) => {
        if (typeof response?.data?.data == "number") {
          setAlreadyExist(response?.data?.data);
          return history.push(`/also_income_module/${response?.data?.data}`);
        } else {
          setAlreadyExist(false);
        }
      });
    },
    600,
    [value?.client_shipment_date, value?.supplier_id, value?.arrival_date, value?.add_to]
  );

  useEffect(() => {
    Axios.get("/api/v1/also_incomes/stores")
      .then((res) => {
        const stores = res.data.stores || {};
        const options = Object.keys(stores).map((groupKey) => ({
          label: groupKey,
          options: Object.entries(stores[groupKey]).map(([code, label]) => ({
            label: label,
            value: code
          }))
        }));
        setDepartments(options);
      })
      .catch((err) => console.error("Fetching departments error:", err));
  }, []);

  useEffect(() => {
    const fetchDisabledDates = async () => {
      try {
        const { data } = await Axios.get("/api/v1/calendars");
        setDisabledDates(data.map((date) => moment(date, "YYYY-MM-DD")));
      } catch (err) {
        console.error("Error fetching disabled dates: ", err);
      }
    };

    fetchDisabledDates();
  }, []);

  // useDebounce(
  //   () => {
  //     Axios.get(
  //       `/api/v1/products/simple_products.json?q[identifier_eq]=${invoiceItem.sku}&edited_title=1`
  //     ).then((response) => {
  //       if (response?.data?.data?.length > 0) {
  //         if (response.data.data.length > 5) return;
  //         const firstItem = response.data.data[0];
  //         setInvoiceItem((prev) => ({
  //           ...prev,
  //           product_title: firstItem.edited_title || firstItem.title,
  //           barcode: firstItem.ean,
  //           sku: firstItem.identifier,
  //         }));
  //       }
  //     });
  //   },
  //   600,
  //   [invoiceItem.barcode]
  // );

  const disabledAddProduct = useMemo(() => {
    const valid = !validate
      .map((d) => invoiceItem[d])
      .every((d) => {
        if (d) return true;
        return false;
      });

    const qty = parseInt(invoiceItem.qty) || 0;
    const minQty = invoiceItem.min_quantity || 0;
    const quantityValid = qty >= minQty;

    if (!valid) {
      const skuHasNonDigits = /[^0-9]/.test(invoiceItem.sku || "");
      if (!skuHasNonDigits) {
        if (!invoiceItem.barcode || !invoiceItem.barcode.trim()) {
          return true;
        }
        if (invoiceItem.barcode.trim().length !== 13) {
          return true;
        }
      }
      return !quantityValid;
    }
    return valid || !quantityValid;
  });

  const disabledAddForm = useMemo(() => {
    if (!value) return true;
    if (!value?.also_income_item?.length) return true;
    return !validateForm
      .map((d) => value[d])
      .every((d) => {
        if (d) return true;
        return false;
      });
  }, [
    ...validateForm.map((d) => (value ? value[d] : false)),
    value?.also_income_item?.length,
  ]);

  const isAdremDepartment = useMemo(() => {
    if (!value?.add_to) return false;
    const code = String(value.add_to).toUpperCase();
    const codeWithoutPrefix = code.replace(/^VV_/, '');
    const extraAdremDivisions = ["U0809", "U08091", "U08092"];
    return code.startsWith("ADREM") || extraAdremDivisions.includes(code) || extraAdremDivisions.includes(codeWithoutPrefix);
  }, [value?.add_to]);

  const isAlsoDepartment = useMemo(() => {
    if (!value?.add_to) return false;
    return value.add_to.toUpperCase().startsWith('ALSO');
  }, [value?.add_to]);

  // const opacityCheck = useMemo(() => {
  //   return typeof invoiceItem?.idx == "number" ? 0.5 : 1;
  // }, [invoiceItem?.idx]);
  useEffect(() => {
    if (value?.id) {
      // setValue((prev) => ({ ...prev, add_to: "ALSO" }));
      setReviewDate(moment(value.review_at));
      setSupplyDate(moment(value.arrival_date));
      setAlreadyExist(false);
    } else {
      setValue((prev) => ({
        ...prev,
        order_date: moment().format("YYYY-MM-DD"),
      }));
    }
  }, [value?.id]);
  if (fetchLoading) {
    return (
      <ModalSpecial
        onClose={() => {
          modalFunc(false);
          removeOverFlow();
        }}
        style={{
          width: 600,
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          <Spinner />
        </div>
      </ModalSpecial>
    );
  }
  if (error) {
    return (
      <ModalSpecial
        onClose={() => modalFunc(false)}
        style={{
          width: 600,
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          {JSON.stringify(error)}
        </div>
      </ModalSpecial>
    );
  }
  const onChange = (e) => {
    const { name, value } = e.target;
    setInvoiceItem((prev) => ({ ...prev, [name]: value }));

    if (name === "vv_sku") {
      setUserTypedVvSku(true);
      setVvSkuStatus({ valid: true, message: "" });
    }

    if (name === "qty") {
      const qty = parseInt(value) || 0;
      const minQty = invoiceItem.min_quantity || 0;

      if (qty < minQty) {
        setQuantityWarning({
          show: true,
          message: `Error: Quantity (${qty}) cannot be less than minimum required (${minQty})`
        });
      } else {
        setQuantityWarning({ show: false, message: "" });
      }
    }
  };

  const onChangeBasic = (e) => {
    const { name, value } = e.target;
    setValue((prev) => ({ ...prev, [name]: value }));
  };

  const submitProduct = async () => {
    const qty = parseInt(invoiceItem.qty) || 0;
    const minQty = invoiceItem.min_quantity || 0;

    if (qty < minQty) {
      setQuantityWarning({
        show: true,
        message: `Error: Quantity (${qty}) cannot be less than minimum required (${minQty})`
      });
      return;
    } else {
      setQuantityWarning({ show: false, message: "" });
    }

    if (userTypedVvSku && invoiceItem.vv_sku?.trim()) {
      try {
        setLoading(true);

        const checkResponse = await Axios.post(
          `/api/v1/products/${invoiceItem.product_id}/check_vv_sku`,
          { vv_sku: invoiceItem.vv_sku }
        );

        if (checkResponse.data?.success === false) {
          setVvSkuStatus({
            valid: false,
            message: checkResponse.data?.message || "VV SKU already exists"
          });
          setLoading(false);
          return;
        }

        setVvSkuStatus({ valid: true, message: "" });
        setUserTypedVvSku(false);
      } catch (error) {
        console.error("Error checking VV SKU:", error);
        setVvSkuStatus({
          valid: false,
          message: error.response?.data?.message || "Error validating VV SKU"
        });
        setLoading(false);
        return;
      }
    }

    let obj = { ...invoiceItem };
    const itemIdx = obj.idx;
    delete obj.idx;
    obj.user_id = user.id;

    setValue((prev) => {
      const also_income_item = [...prev.also_income_item];

      if (itemIdx !== undefined && itemIdx !== null) {
        also_income_item[itemIdx] = obj;
      } else {
        const existingIndex = also_income_item.findIndex(
          (item) => item.sku === obj.sku
        );

        if (existingIndex !== -1) {
          also_income_item[existingIndex].qty =
            parseFloat(also_income_item[existingIndex].qty) +
            parseFloat(obj.qty);
        } else {
          also_income_item.push(obj);
        }
      }

      return { ...prev, also_income_item };
    });

    setInvoiceItem(initialStateItem);
    setVvSkuStatus({ valid: true, message: "" });
    setQuantityWarning({ show: false, message: "" });
    setLoading(false);
  };

  const onEdit = (val, idx) => {
    if (invoiceItem.idx == idx) {
      setInvoiceItem(initialStateItem);
      setQuantityWarning({ show: false, message: "" });
      return;
    }
    setInvoiceItem({ ...val, idx });

    const qty = parseInt(val.qty) || 0;
    const minQty = val.min_quantity || 0;

    if (qty < minQty) {
      setQuantityWarning({
        show: true,
        message: `Error: Quantity (${qty}) cannot be less than minimum required (${minQty})`
      });
    } else {
      setQuantityWarning({ show: false, message: "" });
    }
  };
  const onDelete = (idx) => {
    setValue((prev) => {
      let data = { ...prev };

      const item = data.also_income_item[idx];
      if (item.id) {
        data.also_income_item[idx]._destroy = item._destroy ? 0 : 1;
      } else {
        data.also_income_item.splice(idx, 1);
      }
      return data;
    });
  };

  const onStartEditVvSku = (idx, currentVvSku) => {
    setEditingVvSkuIdx(idx);
    setEditingVvSkuValue(currentVvSku || "");
  };

  const onSaveVvSku = (idx) => {
    setValue((prev) => {
      let data = { ...prev };
      data.also_income_item[idx].vv_sku = editingVvSkuValue;
      return data;
    });
    setEditingVvSkuIdx(null);
    setEditingVvSkuValue("");
  };

  const onCancelEditVvSku = () => {
    setEditingVvSkuIdx(null);
    setEditingVvSkuValue("");
  };

  const onUpdate = async () => {
    try {
      setIsLoading(true);
      const incomeParams = {
        orderRows: value.also_income_item.map((d) => {
          let obj = { ...d };
          delete obj.user_full;
          if (obj.qty !== undefined) {
            obj.quantity = parseInt(obj.qty);
            delete obj.qty;
          }
          return obj;
        }),
        supplierId: value.supplier_id,
        shipment_date: value.client_shipment_date,
        selectedValue: value.add_to || "ALSO",
        review_at: value.review_at,
        supply_date: value.arrival_date,
        has_customs: value.has_customs || false,
        send_email: value.send_email || false,
      };
      console.log(incomeParams, "incomeParams");
      if (value.order_nr) {
        incomeParams.order_nr = value.order_nr;
      }

      if (value.id) {
        incomeParams.id = value.id;
      }

      const { success } = await dispatch(postSupplyingIncome(incomeParams));
      if (success) {
        modalFunc(false);
      }
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoading(false);
    }
  };

  const fetchOptions = async (value) => {
    try {
      // imti tik esancius
      let api_url = `/api/v1/suppliers?page=1&per_page=9999999&q[rivile_supplier_code_null]=0&q[title_or_rivile_supplier_code_i_cont_any]=${value}`;

      const { data } = await Axios.get(api_url);
      const valArr = data?.data?.filter((d) => d.id) || [];
      return (
        valArr.map((e) => ({
          ...e,
          value: e.id,
          label: `${e.rivile_supplier_code} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const fetchProductOptions = async (value) => {
    try {
      let api_url = `/api/v1/products/simple_products.json?q[identifier_eq]=${value}`;

      const { data } = await Axios.get(api_url);
      if (!data?.data) return [];
      return (
        data.data.map((e) => ({
          ...e,
          value: e.identifier,
          label: `${e.identifier} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const fetchProductByVvSku = async (value) => {
    try {
      let api_url = `/api/v1/products/simple_products.json?q[vv_sku_eq]=${value}`;

      const { data } = await Axios.get(api_url);
      if (!data?.data) return [];
      return (
        data.data.map((e) => ({
          ...e,
          value: e.vv_sku,
          label: `${e.vv_sku} - ${e.title}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const fetchProductByBarcode = async (value) => {
    try {
      let api_url = `/api/v1/products/simple_products.json?q[ean_eq]=${value}`;

      const { data } = await Axios.get(api_url);
      if (!data?.data) return [];
      return (
        data.data.map((e) => ({
          ...e,
          value: e.ean,
          label: `${e.ean}`,
        })) || []
      );
    } catch (err) {
      errorHandler(err);
      return [];
    }
  };

  const isWeekend = (date) => {
    const day = date.day();
    return day === 0 || day === 6;
  };

  const disabledDate = (current) => {
    const today = moment().startOf("day");
    return isWeekend(current) || current.isBefore(today);
  };

  const disabledDateReview = (current) => {
    const day = moment(reviewDate).startOf("day");
    return isWeekend(current) || current.isBefore(day);
  };

  const handleDepartmentChange = (value) => {
    console.log("selected department", value);
    onChangeBasic({ target: { name: "add_to", value } });
  };

  const disabledClientShipmentDate = (current) => {
    const day = moment(supplyDate).startOf("day");
    const today = moment().startOf("day");
    return (
      isWeekend(current) ||
      current.isBefore(day) ||
      current.isBefore(today) ||
      disabledDates.some((disabledDate) => current.isSame(disabledDate, "day"))
    );
  };

  const handleCreateVvProduct = () => {
    if (!invoiceItem.sku) {
      message.error("Please enter a product SKU first");
      return;
    }

    confirm({
      title: "Create new VV product?",
      icon: <IconExclamation className="text-primary" />,
      content: "You will not be able to undo this action",
      onOk() {
        const loadingMsg = message.loading("Creating VV product...", 0);

        Axios.post(`/api/v1/products/${invoiceItem?.product_id}/create_vv_product`)
          .then(response => {
            loadingMsg();

            if (response.data?.success !== false) {
              message.success("VV product created successfully");
              if (response.data?.vv_sku) {
                setInvoiceItem(prev => ({ ...prev, vv_sku: response.data.vv_sku }));
                setVvSkuText(response.data.vv_sku);
              }
            } else {
              message.error(response.data?.message || "Failed to create VV product");
            }
          })
          .catch(error => {
            loadingMsg();
            console.error("Error creating VV product:", error);
            message.error(error.response?.data?.message || "Failed to create VV product");
          });
      },
    });
  };

  const handleCreateVvProductForRow = (idx, productId) => {
    if (!productId) {
      message.error("Product ID is missing");
      return;
    }

    confirm({
      title: "Create new VV product?",
      icon: <IconExclamation className="text-primary" />,
      content: "A new VV SKU will be generated for this product",
      onOk() {
        const loadingMsg = message.loading("Creating VV product...", 0);

        Axios.post(`/api/v1/products/${productId}/create_vv_product`)
          .then(response => {
            loadingMsg();

            if (response.data?.success !== false) {
              message.success("VV product created successfully");
              if (response.data?.vv_sku) {
                setValue((prev) => {
                  let data = { ...prev };
                  data.also_income_item[idx].vv_sku = response.data.vv_sku;
                  return data;
                });
                setEditingVvSkuValue(response.data.vv_sku);
              }
            } else {
              message.error(response.data?.message || "Failed to create VV product");
            }
          })
          .catch(error => {
            loadingMsg();
            console.error("Error creating VV product:", error);
            message.error(error.response?.data?.message || "Failed to create VV product");
          });
      },
    });
  };

  // TODO: If selected dapartment is VV then VV SKU should be required
  // TODO: Add search to department select
  return (
    <>
      <ModalSpecial
        style={{
          width: 1000,
        }}
        onClose={() => {
          AntdConfirm({
            title: "Are you sure want to close modal?",
            content: "",
            onOk: () => {
              return modalFunc(false);
            },
          });
        }}
        text={
          <span className="text-black">
            {value.id ? (
              <span>
                Edit income document <span className="text-primary">#</span>
                {value.document_no}
              </span>
            ) : (
              "Create new income document"
            )}
          </span>
        }
      >
        <div className="d-flex flex-column h-100 justify-content-between">
          <div>
            <div className="up-container">
              <div className="row">
                <div className="col-3 pr-1">
                  <Label required={true}>Supplier code</Label>
                  <DebounceSelect
                    labelInValue={false}
                    required={true}
                    showSearch={true}
                    value={value?.supplier_id}
                    initialValue={value?.supplier_code}
                    placeholder={"Type to search"}
                    disabled={
                      isRestrictedStatus || value?.id !== null
                    }
                    fetchOptions={fetchOptions}
                    onChange={(value) => {
                      onChangeBasic({
                        target: {
                          name: "supplier_id",
                          value,
                        },
                      });
                    }}
                    style={{
                      width: "100%",
                    }}
                  />
                </div>
                {/* <div className="mb-2 col-6">
                <TextInputModal
                  required={true}
                  text="Supplier code"
                  name="supplier_code"
                  value={value.supplier_code}
                  onChange={onChangeBasic}
                />
              </div> */}
                <div className="mb-2 col-2 pl-1 pr-1">
                  <DataPickerInputModal
                    required={true}
                    text="Arriving to location"
                    name="arrival_date"
                    disabledDate={disabledDateReview}
                    value={getDateFormat(value.arrival_date)}
                    onChange={(_, ar) => {
                      setSupplyDate(_);
                      onChangeBasic({
                        target: { name: "arrival_date", value: ar },
                      });
                    }}
                  />
                </div>
                <div className="mb-2 col-3 pl-1 pr-1">
                  <DataPickerInputModal
                    required={true}
                    text="Purchase order review date"
                    name="review_at"
                    disabledDate={disabledDate}
                    value={getDateFormat(value.review_at)}
                    onChange={(_, ar) => {
                      setReviewDate(_);
                      onChangeBasic({
                        target: { name: "review_at", value: ar },
                      });
                    }}
                  />
                </div>

                {typeof itAlreadyExist == "number" && (
                  <div className="mb-2 col-12">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>Already exists with that date and supplier code</div>
                      <div
                        style={{
                          width: 100,
                        }}
                      >
                        <ButtonSecondary
                          onClick={() => {
                            history.push(
                              `/also_income_module/${itAlreadyExist}`
                            );
                          }}
                        >
                          Go
                        </ButtonSecondary>
                      </div>
                    </div>
                  </div>
                )}
                <div className="mb-2 col-2 pl-1 pr-1">
                  <DataPickerInputModal
                    required={false}
                    text="Client shipment date"
                    name="client_shipment_date"
                    disabledDate={disabledClientShipmentDate}
                    value={getDateFormat(value.client_shipment_date)}
                    onChange={(_, ar) =>
                      onChangeBasic({
                        target: { name: "client_shipment_date", value: ar },
                      })
                    }
                  />
                </div>
                <div className="col-2 pl-1 pr-1">
                  <Label required={true}>Supplier order number</Label>
                  <TextInputModal
                    disabled={isRestrictedStatus}
                    name="order_nr"
                    value={value.order_nr}
                    onChange={onChangeBasic}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mb-2 col-3 pr-1">
                  <Label required={true}>Department</Label>
                  <Select
                    disabled={isRestrictedStatus}
                    style={{ width: 200 }}
                    onChange={handleDepartmentChange}
                    options={departments}
                    value={value?.add_to}
                    name="add_to"
                    placeholder="Select department"
                  />
                </div>
                {isAdremDepartment && (
                  <div className="mb-2 col-2 pl-1 pr-1">
                    <SwitchComp
                      placeholder="For customs"
                      checked={value.has_customs}
                      disabled={isRestrictedStatus}
                      onChange={() =>
                        onChangeBasic({ target: { name: "has_customs", value: !value.has_customs } })
                      }
                    />
                  </div>
                )}
                {isAlsoDepartment && (
                  <div className="mb-2 col-2 pl-1 pr-1">
                    <SwitchComp
                      placeholder="Send email"
                      checked={value.send_email}
                      disabled={isRestrictedStatus}
                      onChange={() =>
                        onChangeBasic({ target: { name: "send_email", value: !value.send_email } })
                      }
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="up-container modal-row-sticky">
              <div className='row bg-white'>
                {(!isRestrictedStatus || value?.id === null) && (
                  <>
                    {/* <div className="col-12 row">
                      <div className="col-12">
                        <h3 className="text-black text-sm font-semi-bold mt-2">
                          Take to
                        </h3>
                      </div>
                      <div className="col-2 pr-1">
                        <div
                          className="card-type ant-input cursor-pointer"
                          style={{
                            height: 32,
                            borderColor:
                              selectedValue === "ALSO" ? "#03B0F7" : "",
                            backgroundColor:
                              selectedValue === "ALSO" ? "#EDF9FE" : "",
                          }}
                          onClick={() => {
                            setSelectedValue("ALSO");
                            onChangeBasic({
                              target: { name: "add_to", value: "ALSO" },
                            });
                          }}
                        >
                          <Radio
                            className={
                              selectedValue === "ALSO" ? "selected-radio" : ""
                            }
                            style={{
                              color: selectedValue === "ALSO" ? "#03B0F7" : "",
                            }}
                            checked={selectedValue === "ALSO"}
                            value="ALSO"
                          >
                            ALSO
                          </Radio>
                        </div>
                      </div>
                      <div className="col-2 pl-1 pr-1">
                        <div
                          className="card-type ant-input cursor-pointer"
                          style={{
                            height: 32,
                            borderColor:
                              selectedValue === "OFFICE" ? "#03B0F7" : "",
                            backgroundColor:
                              selectedValue === "OFFICE" ? "#EDF9FE" : "",
                          }}
                          onClick={() => {
                            setSelectedValue("OFFICE");
                            onChangeBasic({
                              target: { name: "add_to", value: "OFFICE" },
                            });
                          }}
                        >
                          <Radio
                            className={
                              selectedValue === "OFFICE" ? "selected-radio" : ""
                            }
                            style={{
                              color:
                                selectedValue === "OFFICE" ? "#03B0F7" : "",
                            }}
                            checked={selectedValue === "OFFICE"}
                            value="OFFICE"
                          >
                            Office
                          </Radio>
                        </div>
                      </div>
                      <div className="col-2 pl-1 pr-1">
                        <div
                          className="card-type ant-input cursor-pointer"
                          style={{
                            height: 32,
                            borderColor:
                              selectedValue === "ADREM" ? "#03B0F7" : "",
                            backgroundColor:
                              selectedValue === "ADREM" ? "#EDF9FE" : "",
                          }}
                          onClick={() => {
                            setSelectedValue("ADREM");
                            onChangeBasic({
                              target: { name: "add_to", value: "ADREM" },
                            });
                          }}
                        >
                          <Radio
                            className={
                              selectedValue === "ADREM" ? "selected-radio" : ""
                            }
                            style={{
                              color: selectedValue === "ADREM" ? "#03B0F7" : "",
                            }}
                            checked={selectedValue === "ADREM"}
                            value="ADREM"
                          >
                            Adrem
                          </Radio>
                        </div>
                      </div>
                    </div> */}
                    <div className="col-12">
                      <hr />
                    </div>
                    <div className="mb-2 col-2 pr-1">
                      <DebounceSelect
                        disabled={itAlreadyExist}
                        labelInValue={false}
                        label="SKU"
                        required={true}
                        showSearch={true}
                        value={invoiceItem.sku || undefined}
                        placeholder={"Search by SKU"}
                        fetchOptions={fetchProductOptions}
                        onChange={(_, val) => {
                          setInvoiceItem((prev) => ({
                            ...prev,
                            product_title: val.edited_title || val.title,
                            barcode: val.ean,
                            sku: val.value,
                            vv_sku: val.vv_sku || "",
                            product_id: val.id,
                            min_quantity: val.min_quantity || 0,
                          }));
                          setVvSkuStatus({ valid: true, message: "" });
                          setUserTypedVvSku(false);
                          setQuantityWarning({ show: false, message: "" });
                        }}
                        style={{
                          width: "100%",
                        }}
                        dropdownMatchSelectWidth={true}
                      />
                    </div>
                    <div className="mb-2 col-3 pl-1 pr-1">
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Label required={false} className="text-sm-label">
                            VV SKU
                            {vvSkuEditMode ? (
                              <SearchOutlined
                                style={{ marginLeft: 8, cursor: 'pointer' }}
                                onClick={() => setVvSkuEditMode(false)}
                              />
                            ) : (
                              <EditOutlined
                                style={{ marginLeft: 8, cursor: 'pointer' }}
                                onClick={() => setVvSkuEditMode(true)}
                              />
                            )}
                          </Label>
                        </div>
                        {vvSkuEditMode ? (
                          <Input
                            disabled={itAlreadyExist}
                            value={invoiceItem.vv_sku || ''}
                            onChange={(e) => {
                              setInvoiceItem(prev => ({ ...prev, vv_sku: e.target.value }));
                              setUserTypedVvSku(true);
                              setVvSkuStatus({ valid: true, message: "" });
                            }}
                            placeholder="Enter VV SKU manually"
                          />
                        ) : (
                          <DebounceSelect
                            disabled={itAlreadyExist}
                            labelInValue={false}
                            label={null}
                            required={false}
                            showSearch={true}
                            value={invoiceItem.vv_sku || undefined}
                            placeholder={"Search by VV SKU"}
                            fetchOptions={fetchProductByVvSku}
                            onChange={(_, val) => {
                              setInvoiceItem((prev) => ({
                                ...prev,
                                product_title: val.edited_title || val.title,
                                barcode: val.ean,
                                sku: val.identifier,
                                vv_sku: val.value,
                                product_id: val.id,
                              }));
                              setVvSkuStatus({ valid: true, message: "" });
                              setUserTypedVvSku(false);
                            }}
                            style={{ width: "100%" }}
                            dropdownMatchSelectWidth={true}
                          />
                        )}
                        {!vvSkuStatus.valid && (
                          <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
                            {vvSkuStatus.message}
                          </div>
                        )}
                        <div style={{ marginTop: "8px" }}>
                          <span style={{ fontSize: "12px" }}>Missing? </span>
                          <Button
                            type="link"
                            onClick={handleCreateVvProduct}
                            disabled={itAlreadyExist || !invoiceItem.sku}
                            style={{ padding: 0, fontSize: "12px", height: "auto" }}
                          >
                            Create new VV product
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="mb-2 col-3 pl-1 pr-1">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Label required={false} className="text-sm-label">
                          Barcode
                          {barcodeEditMode ? (
                            <SearchOutlined
                              style={{ marginLeft: 8, cursor: 'pointer' }}
                              onClick={() => setBarcodeEditMode(false)}
                            />
                          ) : (
                            <EditOutlined
                              style={{ marginLeft: 8, cursor: 'pointer' }}
                              onClick={() => setBarcodeEditMode(true)}
                            />
                          )}
                        </Label>
                      </div>
                      {barcodeEditMode ? (
                        <Input
                          disabled={itAlreadyExist}
                          value={invoiceItem.barcode || ''}
                          onChange={e => setInvoiceItem(prev => ({ ...prev, barcode: e.target.value }))}
                          placeholder="Enter barcode manually"
                        />
                      ) : (
                        <DebounceSelect
                          disabled={itAlreadyExist}
                          labelInValue={false}
                          label={null}
                          required={false}
                          showSearch={true}
                          value={invoiceItem.barcode || undefined}
                          placeholder={"Search by Barcode"}
                          fetchOptions={fetchProductByBarcode}
                          onChange={(_, val) => {
                            if (val && val.value) {
                              setInvoiceItem((prev) => ({
                                ...prev,
                                product_title: val.edited_title || val.title,
                                barcode: val.value,
                                sku: val.identifier,
                                vv_sku: val.vv_sku || "",
                                product_id: val.id,
                                min_quantity: val.min_quantity || 0,
                              }));
                              setVvSkuStatus({ valid: true, message: "" });
                              setUserTypedVvSku(false);
                              setQuantityWarning({ show: false, message: "" });
                            }
                          }}
                          style={{ width: "100%" }}
                          dropdownMatchSelectWidth={true}
                        />
                      )}
                    </div>
                    <div className="mb-2 col-3 pl-1 pr-1">
                      <TextInputModal
                        disabled={itAlreadyExist}
                        required={true}
                        text="Title"
                        name="product_title"
                        value={invoiceItem.product_title}
                        onChange={onChange}
                      />
                    </div>

                    <div className="mb-2 col-1 pl-1 pr-1">
                      <TextInputModal
                        disabled={itAlreadyExist}
                        required={true}
                        type="number"
                        text="Quantity"
                        name="qty"
                        value={invoiceItem.qty}
                        onChange={onChange}
                      />
                      {quantityWarning.show && (
                        <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>
                          {quantityWarning.message}
                        </div>
                      )}
                    </div>
                    <div className="mb-2 col-2 pr-1">
                      <div>
                        <ButtonSecondary
                          outline={true}
                          onClick={submitProduct}
                          loading={loading}
                          disabled={itAlreadyExist || disabledAddProduct}
                        >
                          {typeof invoiceItem?.idx == "number"
                            ? "Update"
                            : "Add"}{" "}
                          product
                        </ButtonSecondary>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="up-container">
              <h3 className="text-black text-sm font-semi-bold mt-2">
                Added list
              </h3>
            </div>
            {value.also_income_item.length == 0 ? (
              <div className="bg-silver d-flex align-items-center justify-content-center py-2">
                <IconSadFace className="text-sm" />{" "}
                <span className="ml-2">List is empty, please add product</span>
              </div>
            ) : (
              <div
                className="bg-silver"
                style={{
                  height: "auto",
                  display: "block",
                  width: "101.5%",
                  marginBottom: 50,
                }}

              // style={{
              //   opacity: opacityCheck,
              // }}
              >
                <TableUi
                  hoverable={false}
                  ths={["SKU", "VV SKU", "Barcode", "Title", "User", "Qty.", ""]}
                >
                  {value.also_income_item.map((e, idx) => {
                    return (
                      <TableUi.tr
                        className={`align-middle tableColumn ${e._destroy
                          ? "opacity-25"
                          : typeof invoiceItem.idx == "number"
                            ? invoiceItem?.idx == idx
                              ? "opacity-100"
                              : "opacity-50"
                            : ""
                          }`}
                        key={`${e.id || 0}_${idx}`}
                      >
                        <TableUi.td className={"p-left"}>{e.sku}</TableUi.td>
                        <TableUi.td>
                          {editingVvSkuIdx === idx ? (
                            <div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                <Input
                                  size="small"
                                  value={editingVvSkuValue}
                                  onChange={(ev) => setEditingVvSkuValue(ev.target.value)}
                                  style={{ width: '120px' }}
                                />
                                <Button size="small" type="primary" onClick={() => onSaveVvSku(idx)}>✓</Button>
                                <Button size="small" onClick={onCancelEditVvSku}>✗</Button>
                              </div>
                              {e.product_id && (
                                <div style={{ marginTop: '4px' }}>
                                  <Button
                                    type="link"
                                    size="small"
                                    onClick={() => handleCreateVvProductForRow(idx, e.product_id)}
                                    style={{ padding: 0, fontSize: '11px', height: 'auto' }}
                                  >
                                    Create new VV product
                                  </Button>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                              <span>{e.vv_sku || "-"}</span>
                              {isRestrictedStatus && value?.id !== null && (
                                <EditOutlined
                                  style={{ cursor: 'pointer', fontSize: '12px' }}
                                  onClick={() => onStartEditVvSku(idx, e.vv_sku)}
                                />
                              )}
                            </div>
                          )}
                        </TableUi.td>
                        <TableUi.td>{e.barcode}</TableUi.td>
                        <TableUi.td>{e.product_title}</TableUi.td>
                        <TableUi.td>
                          {e.user_full
                            ? e.user_full
                            : e.user_id == user.id
                              ? `${user.firstname || ""} ${user.lastname || ""}`
                              : "-"}
                        </TableUi.td>
                        <TableUi.td>
                          {e.qty}/{e.used_qty}
                        </TableUi.td>
                        <TableUi.td>
                          {(!isRestrictedStatus ||
                            value?.id === null) && (
                              <div className="d-flex flex-row align-items-end justify-content-end">
                                <ButtonSmall
                                  type={idx == invoiceItem.idx ? "outline" : ""}
                                  className="mr-1"
                                  onClick={() => onEdit(e, idx)}
                                >
                                  <IconEdit
                                    color={
                                      idx !== invoiceItem.idx ? "#fff" : "#007BFF"
                                    }
                                  />
                                </ButtonSmall>
                                <ButtonDelete onDelete={() => onDelete(idx)} />
                              </div>
                            )}
                        </TableUi.td>
                      </TableUi.tr>
                    );
                  })}
                </TableUi>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            width: 910,
            backgroundColor: "white",
            position: "fixed",
            bottom: 0,
            right: 0,
            height: 55,
            paddingRight: 25,
            paddingTop: 15,
            borderTop: "1px solid #E5E5E5",
            boxShadow: "0px -4px 6px 0px #0000000D",
          }}
        >
          <div className="w-25 float-right">
            <ButtonSecondary
              onClick={() => onUpdate()}
              loading={isLoading || fetchLoading}
              disabled={disabledAddForm}
            >
              {value.id ? "Update document" : "Create"}
            </ButtonSecondary>
          </div>
        </div>
      </ModalSpecial>
    </>
  );
};
export default ModalAlsoIncomeModule;
